import repository from "../Repository";

export default {
  async list() {
    return await repository.post("fixed_phrase");
  }
};
